import { Component } from '@angular/core';
import { ScrollAnimateDirective } from '../../../directives/scroll-animate.directive';

@Component({
  selector: 'app-organizer-line',
  imports: [ScrollAnimateDirective],
  templateUrl: './organizer-line.html',
  styleUrl: './organizer-line.css',
})
export class OrganizerLine {}
